export default "__VITE_ASSET__BBN9OZ8E__"